// src/components/forms/fields/SelectField.tsx
// Utworzony w Krok 3

import React from 'react';
import { 
  FormControl, 
  FormLabel, 
  RadioGroup, 
  FormControlLabel, 
  Radio,
  Select,
  MenuItem,
  InputLabel,
  FormHelperText,
  Box 
} from '@mui/material';
import { FormSection } from '../../../types/forms';

interface SelectFieldProps {
  section: FormSection;
  value: any;
  onChange: (value: any) => void;
  error?: string;
}

export const SelectField: React.FC<SelectFieldProps> = ({ section, value, onChange, error }) => {
  const options = section.config?.options || [];
  const component = section.config?.component || 'select';
  
  if (component === 'radio') {
    return (
      <Box sx={{ mb: 3 }}>
        <FormControl error={!!error} required={!!section.validation?.required}>
          <FormLabel component="legend">{section.label}</FormLabel>
          <RadioGroup
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            sx={{ mt: 1 }}
          >
            {options.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio />}
                label={option.label}
              />
            ))}
          </RadioGroup>
          {(error || section.description) && (
            <FormHelperText>{error || section.description}</FormHelperText>
          )}
        </FormControl>
      </Box>
    );
  }

  // Default: dropdown select
  return (
    <Box sx={{ mb: 3 }}>
      <FormControl fullWidth error={!!error} required={!!section.validation?.required}>
        <InputLabel>{section.label}</InputLabel>
        <Select
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          label={section.label}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
        {(error || section.description) && (
          <FormHelperText>{error || section.description}</FormHelperText>
        )}
      </FormControl>
    </Box>
  );
};
